import { render, staticRenderFns } from "./IPLicenseDetails.vue?vue&type=template&id=17dbb51c&scoped=true&"
import script from "./IPLicenseDetails.vue?vue&type=script&lang=js&"
export * from "./IPLicenseDetails.vue?vue&type=script&lang=js&"
import style0 from "./IPLicenseDetails.vue?vue&type=style&index=0&id=17dbb51c&prod&lang=css&"
import style1 from "./IPLicenseDetails.vue?vue&type=style&index=1&id=17dbb51c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dbb51c",
  null
  
)

export default component.exports